var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-group-item-wrapper",on:{"click":_vm.click}},[_c('mds-list-group-item',{attrs:{"text":_vm.displayName,"metadata-below":_vm.metadata}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }